import Store from 'app/redux/store'
import Redux from 'app/interface/redux'
import { bindActions } from 'redux-zero/utils'
import { AxiosResponse } from 'axios'
import { UserWithBusiness } from '@marketing-milk/interfaces'
import { NestAPI } from '../../../../nestapi'

const Master = bindActions(
  store => ({
    init: async (): Promise<void> => {
      const users: AxiosResponse<UserWithBusiness[]> = await NestAPI.get('users')
      const state: Redux = store.getState()
      store.setState({
        data: {
          ...state.data,
          generic: {
            ...state.data.generic,
            users: {
              data: users,
              loading: false,
              timestamp: +new Date(),
            },
          },
        },
      })
    },
  }),
  Store
)

export default Master
